// extracted by mini-css-extract-plugin
export var contentBody = "_a3-9";
export var headerImage = "_a3-2";
export var imageButton = "_a3-7";
export var imageButtonIcon = "_a3-8";
export var imageHeader = "_a3-4";
export var imageHeaderText = "_a3-5";
export var imageOverlay = "_a3-3";
export var imageTitle = "_a3-6";
export var imageWrapper = "_a3-1";
export var taskList = "_a3-a";
export var widget = "_a3-0";